export const STILL_CONNECTING_HINT_MS = 8000

export const SUPPORT_CHAT_TIMEOUT_MS = 60_000
